import { Box } from '@mui/material';
import { FileManagement } from 'api/model';
import ScopeIndicator from 'components/indicators/ScopeIndicator';

type FileRendererProps = {
  file?: FileManagement;
  fallback: string;
};

const FileRenderer = ({ file, fallback }: FileRendererProps) => {
  if (!file) return <span>{fallback}</span>;

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" gap={1}>
      <span>{file.file_name}</span>
      <ScopeIndicator isGlobal={file.project_id == null} />
    </Box>
  );
};

export default FileRenderer;
